import { useNavigate } from "react-router-dom";
import { Button } from "../shared/button";
import { LogIn, UserRound, LogOut, Loader2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../shared/dropdown-menu";
import { useAuthController } from "@/hooks/useAuthController";
import { ROUTES } from "@/config/routes";

export const AuthButtons = () => {
  const navigate = useNavigate();
  const { user, status, signOut, isLoading } = useAuthController();

  const handleLogout = async () => {
    const { error } = await signOut();
    if (error) {
      // Error handling is done in AuthContext
      console.error('Logout error:', error);
    }
    // Navigation is handled by the auth controller
  };

  const handleSignIn = () => {
    navigate(ROUTES.LOGIN);
  };

  if (isLoading || status === 'loading') {
    return (
      <Button 
        variant="outline" 
        disabled
        className="text-white bg-[#CA0079] gap-[11px] whitespace-nowrap px-4 sm:px-[31px] py-[10px] sm:py-[13px] rounded-[10px] transition-colors text-sm sm:text-base opacity-50"
        aria-label="Loading authentication status"
      >
        <Loader2 className="h-4 w-4 animate-spin" />
        Loading...
      </Button>
    );
  }

  if (user) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button 
            variant="outline" 
            className="text-white bg-[#CA0079] gap-[11px] whitespace-nowrap px-4 sm:px-[31px] py-[10px] sm:py-[13px] rounded-[10px] hover:bg-[#a0005f] transition-colors text-sm sm:text-base"
            aria-label={`Signed in as ${user.email}`}
          >
            <UserRound className="h-4 w-4" />
            {user.email}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem 
            onClick={handleLogout}
            disabled={status === 'loading'}
            aria-label="Sign out"
          >
            <LogOut className="h-4 w-4 mr-2" />
            {status === 'loading' ? 'Signing out...' : 'Sign out'}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <Button 
      variant="outline"
      onClick={handleSignIn}
      className="text-white bg-[#CA0079] gap-[11px] whitespace-nowrap px-4 sm:px-[31px] py-[10px] sm:py-[13px] rounded-[10px] hover:bg-[#a0005f] transition-colors text-sm sm:text-base"
      aria-label="Sign in to your account"
    >
      <LogIn className="h-4 w-4" />
      Sign in
    </Button>
  );
};